import api from '..';

export const getEconomicCalendarRequest = ({ theme, lang }) =>
  api.get('/economic-calendar', { params: { theme, lang } });

export const getEconomicCalendarPublicRequest = ({ theme, lang }) =>
  api.get('/economic-calendar/public', { params: { theme, lang } });
